import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { LanguageService, NgxToastrService, TrainService, UtilsService } from "@core/services";
import { TranslateService } from "@ngx-translate/core";
import { TrainsSearchComponent } from "../train-search/train-search.component";
import { TrainsInfo } from "@core/models/trainsInfo";
import { TrainSearchRequest } from "@core/models/trains/train-search-request";
import { TrainInfoModalComponent } from "../train-info-modal/train-info-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-train-search-result",
  templateUrl: "./train-search-result.component.html",
  styleUrls: ["./train-search-result.component.scss"],
})
export class TrainSearchResultComponent implements OnInit, OnDestroy {
  @Input() searchHasFailed: boolean;
  onView: string = "outward"
  trainsInfo: TrainsInfo;
  flexibilityString: string[] = []
  searchDialog: any;
  constructor(
    private router: Router,
    private dialog: MatDialog,
    public utilsService: UtilsService,
    public trainService: TrainService,
    public translate: TranslateService,
    private ngxToastrService: NgxToastrService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private langService: LanguageService,
  ) {
    this.utilsService.socket.on("search-outward", (res) => {
      this.searchOutwardResponse(res);
    });
    this.utilsService.socket.on("search-return", (res) => {
      this.searchReturnResponse(res);
    });
    this.utilsService.socket.on("select-trains", (res) => {
      this.selectTrainsResponse(res);
    });
    this.trainService.getTrainsInfo$().subscribe((info: TrainsInfo) => {
      this.trainsInfo = info;
    });

    this.route.queryParams.subscribe((params) => {
      if (this.trainsInfo.didSearch === true) {
        this.onSearch();
      }
    });

    if (this.trainsInfo == null) {
      this.router.navigate(["train"]);
    }
  }

  ngOnDestroy(): void {
    this.utilsService.socket.off('search-outward');
    this.utilsService.socket.off('search-return');
    this.utilsService.socket.off('select-trains');
  }

  ngOnInit(): void {
    this.translate
      .get(["train.non-flexi", "train.semi-flexi", "train.flexi"])
      .subscribe((result) => {
        this.flexibilityString = result;
      })
    if (!this.trainsInfo.selectedTrains) {
      this.trainService.selectTrain(this.trainsInfo.trainsList.outward[0], 'outward', this.trainsInfo)
    }
  }

  changeSearchParams() {
    this.searchDialog = this.dialog.open(TrainsSearchComponent, {
      height: "auto",
      width: "90%",
      panelClass: "search-train-dialog",
      data: { modal: true },
    });
    this.trainService.setTrainsInfoPartial({ isModal: true })
    this.searchDialog.afterClosed().subscribe((result) => {
      this.trainService.setTrainsInfoPartial({ isModal: false })
      this.onView = 'outward'
    });
  }

  selectAlternative(train: any, alternative: any, type: string) {
    let selectedTrains: any = this.trainsInfo.selectedTrains ? { ...this.trainsInfo.selectedTrains } : {}
    if (type === 'outward') {
      selectedTrains.selectedOutwardTrain = train;
      selectedTrains.selectedOutwardAlternatives = alternative;
    } else if (type === 'return') {
      selectedTrains.selectedReturnTrain = train;
      selectedTrains.selectedReturnAlternatives = alternative;
    }
    this.trainService.setTrainsInfoPartial({ selectedTrains: selectedTrains })
  }

  onSearch(paging?: string) {
    if (this.trainService.checkOriginOrDestinationMatch(this.trainsInfo) === false) {
      this.trainService.setTrainsInfoPartial({
        searchConfig: {
          departDate: this.trainsInfo.formSearchTrain.value.departDate,
          returnDate: this.trainsInfo.formSearchTrain.value.returnDate ? this.trainsInfo.formSearchTrain.value.returnDate : null,
          travellers: this.trainsInfo.formSearchTrain.value.travellers,
          origin: this.trainsInfo.searchConfig.origin,
          destination: this.trainsInfo.searchConfig.destination,
          oneWay: this.trainsInfo.searchConfig.oneWay,
          project: this.trainsInfo.formSearchTrain.value.selectedProject
        }
      });
      this.trainService.setTrainsInfoPartial({ travellers: this.trainsInfo.formSearchTrain.value.travellers });
      /* const projectData = {
        selectedProject: this.selectedProject,
        allProjects: this.projects
      }; */
      this.utilsService.loadingTrains = true;
      const correlation = crypto.randomUUID();
      const request: TrainSearchRequest = {
        language: this.langService.getLanguage(),
        origin: this.trainsInfo.searchConfig.origin,
        destination: this.trainsInfo.searchConfig.destination,
        departDate: this.utilsService.combineDateAndTime(this.trainsInfo.searchConfig.departDate, this.trainsInfo.formSearchTrain.value.departTime),
        oneWay: this.trainsInfo.searchConfig.oneWay != null ? this.trainsInfo.searchConfig.oneWay : false,
        userUuid: this.trainsInfo.userUuid,
        passengers: this.trainsInfo.searchConfig.travellers,
        correlationId: correlation,
      };
      if (paging) {
        request.paging = {
          direction: paging,
          providerRequestId: this.trainsInfo.providerContextOutwardId
        }
      }
      this.trainService.addCorrelation(correlation);

      this.trainsInfo.searchConfig.oneWay = request.oneWay;
      this.trainService.setTrainsInfoPartial({ searchConfig: this.trainsInfo.searchConfig });


      if (this.trainsInfo.searchConfig.returnDate && !this.trainsInfo.searchConfig.oneWay) {
        request["returnDate"] = this.utilsService.combineDateAndTime(this.trainsInfo.searchConfig.returnDate, this.trainsInfo.formSearchTrain.value.returnTime);
      }

      this.trainService.searchTrainsOutward(request).subscribe(
        (s) => {
          this.trainsInfo.selectedTrains = null;
          this.trainsInfo.selectedExtras = null;
          this.trainsInfo.selectedSeats = null;
        },
        (err) => {
          this.utilsService.loadingTrains = false;
          this.searchHasFailed = true;
          if (err.status === 818) {
            this.translate
              .get(["train.notAvailable"])
              .subscribe((result) => {
                this.utilsService.loadingTrains = false;
                this.ngxToastrService.typeInfo(
                  "Error",
                  result["train.notAvailable"]
                );
              })
          } else {
            this.translate
              .get(["train.messages.error"])
              .subscribe((result) => {
                this.ngxToastrService.typeInfo(
                  "Error",
                  result["train.messages.error"]
                );
                this.utilsService.loadingTrains = false;
              })
          }
        }
      )
    }
  }

  onSearchReturn(paging?: string) {
    this.utilsService.loadingTrains = true;
    const correlation = crypto.randomUUID();
    const request: any = {
      language: this.langService.getLanguage(),
      outwardJourneyId: this.trainsInfo.selectedTrains.selectedOutwardTrain.trainId,
      outwardAlternativeIds: this.trainsInfo.selectedTrains.selectedOutwardAlternatives,
      correlationId: correlation,
      userUuid: this.trainsInfo.userUuid,
    }
    if (paging) {
      request.paging = {
        direction: paging,
        providerRequestId: this.trainsInfo.providerContextReturnId
      }
    }
    this.trainService.addCorrelation(correlation);
    this.trainService.searchTrainsReturn(request).subscribe(
      (s) => {
        this.onView = "return";
        this.trainsInfo.selectedTrains.selectedReturnTrain = null;
        this.trainsInfo.selectedTrains.selectedReturnAlternatives = null;
      },
      (err) => {
        this.utilsService.loadingTrains = false;
        this.searchHasFailed = true;
        if (err.status === 818) {
          this.translate
            .get(["train.notAvailable"])
            .subscribe((result) => {
              this.utilsService.loadingTrains = false;
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.notAvailable"]
              );
            })
        } else {
          this.translate
            .get(["train.messages.error"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.messages.error"]
              );
              this.utilsService.loadingTrains = false;
            })
        }
      }
    )
  }

  onSelectTrains() {
    this.utilsService.loadingTrains = true;
    const correlation = crypto.randomUUID();
    const request: any = {
      language: this.langService.getLanguage(),
      outwardId: this.trainsInfo.selectedTrains.selectedOutwardTrain.trainId,
      outwardAlternativeIds: this.trainsInfo.selectedTrains.selectedOutwardAlternatives,
      correlationId: correlation,
    }

    this.trainService.setTrainsInfoPartial({
      selectedTrains: {
        selectedOutwardTrain: this.trainsInfo.selectedTrains.selectedOutwardTrain,
        selectedOutwardAlternatives: this.trainsInfo.selectedTrains.selectedOutwardAlternatives,
        selectedReturnTrain: this.trainsInfo.selectedTrains.selectedReturnTrain,
        selectedReturnAlternatives: this.trainsInfo.selectedTrains.selectedReturnAlternatives,
      }
    });

    if (this.trainsInfo.searchConfig.returnDate) {
      request['returnId'] = this.trainsInfo.selectedTrains.selectedReturnTrain.trainId;
      request['returnAlternativeIds'] = this.trainsInfo.selectedTrains.selectedReturnAlternatives;
    }
    this.trainService.addCorrelation(correlation);
    this.trainService.selectTrains(request).subscribe(
      (s) => {
      },
      (err) => {
        this.utilsService.loadingTrains = false;
        this.searchHasFailed = true;
        if (err.status === 818) {
          this.translate
            .get(["train.notAvailable"])
            .subscribe((result) => {
              this.utilsService.loadingTrains = false;
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.notAvailable"]
              );
            })
        } else {
          this.translate
            .get(["train.messages.error"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.messages.error"]
              );
              this.utilsService.loadingTrains = false;
            })
        }
      }
    )
  }

  searchReturnResponse(res: any) {
    if (this.trainService.existsCorrelation(res.correlationId)) {
      this.trainService.removeCorrelation(res.correlationId)
      this.utilsService.loadingTrains = false;
      if ((res.data.type && (res.data.type?.toLowerCase().includes("error") || res.data.type?.toLowerCase().includes("exception"))) || (res.data.bookingStatus && (res.data.bookingStatus?.toLowerCase().includes('unknown') || res.data.bookingStatus?.toLowerCase().includes('error')))) {
        this.searchHasFailed = true;
        if (res.data?.status === 818) {
          this.translate
            .get(["train.notAvailable"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.notAvailable"]
              );
            })
        } else if (res?.data?.message?.toLowerCase().includes('invalid card') && this.trainsInfo.searchConfig.travellers.some((t: any) => t.selectedCard)) {
          this.translate
            .get(["train.invalid-card"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                'Error',
                'train.invalid-card'
              );
            })
        } else {
          this.translate
            .get(["train.messages.error"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.messages.error"]
              );
            })
        }
      } else {
        console.log(res)
        if (!res.data.return || res.data.return.length <= 0) {
          this.translate
            .get(["train.search-result.no-trains"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.search-result.no-trains"]
              );
            })
        } else {
          const copyTrainList = { ...this.trainsInfo.trainsList }
          copyTrainList.return = res?.data.return;
          this.trainsInfo.providerContextReturnId = res.data.context.providerRequestId;
          this.trainService.setTrainsInfoPartial({ trainsList: copyTrainList });
          if (!this.trainsInfo.selectedTrains.selectedReturnTrain) {
            this.trainService.selectTrain(this.trainsInfo.trainsList.return[0], 'return', this.trainsInfo)
          }
        }
      }
    }
  }

  selectTrainsResponse(res: any) {
    if (this.trainService.existsCorrelation(res.correlationId)) {
      this.trainService.removeCorrelation(res.correlationId)
      this.utilsService.loadingTrains = false;
      if ((res.data.type && (res.data.type?.toLowerCase().includes("error") || res.data.type?.toLowerCase().includes("exception"))) || (res.data.bookingStatus && (res.data.bookingStatus?.toLowerCase().includes('unknown') || res.data.bookingStatus?.toLowerCase().includes('error')))) {
        this.searchHasFailed = true;
        if (res.data?.status === 818) {
          this.translate
            .get(["train.notAvailable"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.notAvailable"]
              );
            })
        } else if (res?.data?.message?.toLowerCase().includes('invalid card') && this.trainsInfo.searchConfig.travellers.some((t: any) => t.selectedCard)) {
          this.translate
            .get(["train.invalid-card"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                'Error',
                'train.invalid-card'
              );
            })
        } else if (res?.data?.message?.toLowerCase().includes('One or more of the chosen fares have expired')) {
          this.translate
            .get(["train.search-result.timer.end"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                'Error',
                'train.search-result.timer.end'
              );
            })
        } else {
          this.translate
            .get(["train.messages.error"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.messages.error"]
              );
            })
        }
      } else {
        console.log(res)
        this.trainsInfo.selectedExtras = null;
        this.trainsInfo.selectedSeats = null;
        this.trainService.setTrainsInfoPartial({ didSearch: true });
        this.trainService.setTrainsInfoPartial({ itineraryId: res?.data?.itineraryId });
        this.trainService.setTrainsInfoPartial({ reservability: res?.data?.reservability });
        this.trainService.setTrainsInfoPartial({ token: res?.data?.token });
        this.trainService.setTrainsInfoPartial({ canChooseSeat: res?.data?.seatMaps?.length > 0 });
        this.trainService.setTrainsInfoPartial({ canChooseExtra: res?.data?.sectionExtras?.some((section) => section.extras.length > 0) });
        this.trainService.setTrainsInfoPartial({ seatMaps: res?.data?.seatMaps });
        this.trainService.setTrainsInfoPartial({ sectionExtras: res?.data?.sectionExtras });
        this.trainsInfo.trainsList.outward = []
        this.trainsInfo.selectedTrains.selectedOutwardTrain.trainId = res?.data?.outwardTrain.trainId
        this.trainsInfo.selectedTrains.selectedOutwardTrain.sectionId = res?.data?.outwardTrain.sectionId
        this.trainsInfo.selectedTrains.selectedOutwardTrain.sections = res.data.outwardTrain.sections
        if (!this.trainsInfo.searchConfig?.oneWay) {
          this.trainsInfo.trainsList.return = []
          this.trainsInfo.selectedTrains.selectedReturnTrain.trainId = res?.data?.returnTrain.trainId
          this.trainsInfo.selectedTrains.selectedReturnTrain.sectionId = res?.data?.returnTrain.sectionId
          this.trainsInfo.selectedTrains.selectedReturnTrain.sections = res.data.returnTrain.sections
        }
        this.router.navigate(["train/confirm-stepper"]);
      }
    }
  }

  getFlexibilityString(flexibility: string) {
    switch (flexibility?.toLowerCase()) {
      case "flexi":
        return this.flexibilityString["train.flexi"];
      case "semiflexi":
        return this.flexibilityString["train.semi-flexi"];
      case "nonflexi":
      default:
        return this.flexibilityString["train.non-flexi"];
    }
  }

  searchOutwardResponse(res: any) {
    if (this.trainService.existsCorrelation(res.correlationId)) {
      this.trainService.removeCorrelation(res.correlationId)
      this.utilsService.loadingTrains = false;
      if ((res.data.type && (res.data.type?.toLowerCase().includes("error") || res.data.type?.toLowerCase().includes("exception"))) || (res.data.bookingStatus && (res.data.bookingStatus?.toLowerCase().includes('unknown') || res.data.bookingStatus?.toLowerCase().includes('error')))) {
        this.searchHasFailed = true;
        if (res.data?.status === 818) {
          this.translate
            .get(["train.notAvailable"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.notAvailable"]
              );
            })
        } else if (res?.data?.message?.toLowerCase().includes('invalid card') && this.trainsInfo.searchConfig.travellers.some((t: any) => t.selectedCard)) {
          this.translate
            .get(["train.invalid-card"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                'Error',
                'train.invalid-card'
              );
            })
        } else {
          this.translate
            .get(["train.messages.error"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.messages.error"]
              );
            })
        }
      } else {
        console.log(res)
        if (!res.data.outward || res.data.outward.length <= 0) {
          this.translate
            .get(["train.search-result.no-trains"])
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                "Error",
                result["train.search-result.no-trains"]
              );
            })
        } else {
          this.trainsInfo.providerContextOutwardId = res.data.context.providerRequestId;
          this.trainService.setTrainsInfoPartial({ trainsList: res?.data });
          if (!this.trainsInfo.selectedTrains) {
            this.trainService.selectTrain(this.trainsInfo.trainsList?.outward[0], 'outward', this.trainsInfo)
          }
          if (!this.trainsInfo.isModal) {
            this.router.navigate(["train/search-result"]);
          } else {
            this.searchDialog.close()
          }
        }
      }
    }
  }

  onViewDepart() {
    this.onView = 'outward'
  }

  getTrainPrice(train) {
    return (train.price * 1).toFixed(2);
  }

  openSectionsModal(train) {
    const modalRef = this.modalService.open(TrainInfoModalComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.train = train;
  }

  isSelected(train, journey: string) {
    const trainAlternatives = train.sections.map((s) => s.alternativeId);
    if (journey === 'outward') {
      const selectedAlternatives = this.trainsInfo.selectedTrains?.selectedOutwardAlternatives
      return this.trainsInfo.selectedTrains?.selectedOutwardTrain?.trainId === train.trainId
        && selectedAlternatives.length === trainAlternatives.length &&
        [...selectedAlternatives].sort().toString() === [...trainAlternatives].sort().toString();
    } else if (journey === 'return') {
      const selectedAlternatives = this.trainsInfo.selectedTrains?.selectedReturnAlternatives
      return this.trainsInfo.selectedTrains?.selectedReturnTrain?.trainId === train.trainId
        && selectedAlternatives.length === trainAlternatives.length &&
        [...selectedAlternatives].sort().toString() === [...trainAlternatives].sort().toString();
    }
  }

  isPriceWithinRangeMethod(train): boolean {
    let price: number = train.finalPrice ?? train.price ?? 0;
    if (this.trainsInfo.selectedTrains.selectedOutwardTrain && this.onView === 'return') {
      price += this.trainsInfo.selectedTrains.selectedOutwardTrain.finalPrice ?? this.trainsInfo.selectedTrains.selectedOutwardTrain.price ?? 0;
    }
    if (
      !this.trainsInfo.userFilters ||
      this.trainsInfo.userFilters?.priceMinTrain == null ||
      this.trainsInfo.userFilters?.priceMaxTrain == null
    ) {
      return true;
    }

    return (
      price >= this.trainsInfo.userFilters.priceMinTrain &&
      price <= this.trainsInfo.userFilters.priceMaxTrain
    );
  }

  goBack() {
    if (!this.trainsInfo.didSearch) {
      this.trainsInfo.didSearch = false;
      this.router.navigate([`/companies/${this.trainsInfo.user.companyUuid}`])
    } else {
      this.trainsInfo.didSearch = false;
      this.router.navigate([`/train`])
    }
  }

  isDifferentDay(current: any, previous: any): boolean {
    const d1 = new Date(current.departDate);
    const d2 = new Date(previous.departDate);

    return d1.toDateString() !== d2.toDateString();
  }

  formatDate(date: string): string {
    return new Date(date).toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'long'
    });
  }
}
